/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import classNames from 'classnames';
import React from 'react';

import { Modal, ModalBody, ModalHeader, Node } from '..';

export interface IModalViewProps {
    classNames?: string;
    galleryCarousel: React.ReactElement;
    modalIsOpen: boolean;
    ontoggle(): void;
}

export const ImagefullView: React.FC<IModalViewProps> = (props: IModalViewProps): React.ReactElement => {
    const body = (
        <Node tag={ModalBody} className='msc-fullview-modal-body'>
            { props.galleryCarousel }
        </Node>
    );

    const modalWindow = (
        <Modal
            autoFocus
            applicationNode='renderPage'
            isOpen={props.modalIsOpen}
            toggle={props.ontoggle}
            className={classNames('msc-fullview-modal', props.classNames)}
            zIndex={1050}
        />
    );

    const modalHeader = (
        <ModalHeader toggle={props.ontoggle} />
    );

    return React.cloneElement(modalWindow, {}, modalHeader, body);
};
